var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/ElementPath.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { BaseClassifier } from '../BaseClassifierRepo';
import { Id } from '../Id';
import { ApiDomain } from '../domain';
import { AssemblyClassifier } from '..';
import { UserClassifier } from './UserClassifier';
export var ElementPathClassifier;

(function (_ElementPathClassifier) {
  var domain = ApiDomain.domain('ElementPathClassifier', {
    name: "domain",
    sid: "-gnvy6t"
  });
  var io = _ElementPathClassifier.io = t.recursion('ElementPathClassifier', function () {
    return t.type({
      classifier: t.union([t.type({
        id: Id,
        type: t.literal(UserClassifier.type)
      }), t.type({
        id: Id,
        type: t.literal(BaseClassifier.type)
      }), t.type({
        id: Id,
        type: t.literal(AssemblyClassifier.type)
      })]),
      source: t["boolean"],
      path: t.array(t.type({
        id: Id,
        type: t.union([t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily'), t.literal('BimStandardSize'), t.literal('BimElement'), t.literal('UserClassifierGroupWithElements'), t.literal('UserClassifierGroupWithGroups'), t.literal('UserClassifierEmptyGroup')])
      }))
    });
  });
  var ElementPathClassifierResponse = _ElementPathClassifier.ElementPathClassifierResponse = t.type({
    elementPathList: t.array(ElementPathClassifier.io)
  });
  var getElementPath = _ElementPathClassifier.getElementPath = ApiCallService.create({
    name: 'getElementPath',
    parentDomain: domain,
    result: ElementPathClassifierResponse,
    getKey: ['id', 'version', 'elementId', 'elementType']
  });
})(ElementPathClassifier || (ElementPathClassifier = {}));